module.exports = __webpack_public_path__ + "img/NEO.dd464944.svg";